import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequisitionNumber } from 'TimelogDataTypes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequisitionNumberService {
  constructor(private http: HttpClient) {}

  getRequisitionNumbers(): Observable<RequisitionNumber[]> {
    return this.http.get<RequisitionNumber[]>('/api/requisitionNumber');
  }

  upsertRequisitionNumber(
    requisitionNumber: RequisitionNumber
  ): Observable<string> {
    return this.http.put('/api/RequisitionNumber', requisitionNumber, {
      responseType: 'text',
    });
  }

  deleteRequisitionNumber(id: number): Observable<RequisitionNumber> {
    return this.http.delete<RequisitionNumber>('/api/RequisitionNumber/' + id);
  }
}
